const initialState = {
    resultsDestinationsList: [],
    resultsDestinationGet: [],
    resultsDestinationsSgwDetail: [],
    resultsDestinationsDelete: {},
    resultsDestinationsUpdate: {},
    resultsDestinationsAdd: {}
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "LIST_DESTINATIONS_SGW_RESPONSE_GET":
            newState.resultsDestinationsList = action.value;
            break;
        case "LIST_DESTINATIONS_SGW_DETAIL_RESPONSE_GET":
            newState.resultsDestinationsSgwDetail = action.value;
            break;
        case "LIST_DESTINATIONS_RESPONSE_GET":
            newState.resultsDestinationGet = action.value;
            break;
        case "DESTINATION_RESPONSE_DELETE":
            newState.resultsDestinationsDelete = action.value;
            break;
        case "DESTINATION_RESPONSE_UPDATE":
            newState.resultsDestinationsUpdate = action.value;
            break;
        case "DESTINATION_RESPONSE_ADD":
            newState.resultsDestinationsAdd = action.value;
            break;

        case "DESTINATIONS_RESPONSE_RESET":
            newState.resultsDestinationsList = [];
            newState.resultsDestinationGet = [];
            newState.resultsDestinationsSgwDetail = [];
            newState.resultsDestinationsDelete = {};
            newState.resultsDestinationsUpdate = {};
            newState.resultsDestinationsAdd = {};
            break;
            
        case "RESET_DESTINATIONS_GET":
            newState.resultsDestinationsList = [];
            newState.resultsDestinationsSgwDetail = [];
            newState.resultsDestinationGet = [];
            break;
        
        default:
            break;
    }
    return newState;
};

export default reducer;
